"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgGiftF = function SvgGiftF(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M2.024 10.928h5.034v5.02H3.053s-.953.049-1.03-.987v-4.033zm12.042 0v4.033c-.076 1.036-1.029.987-1.029.987H9.032v-5.02h5.034zm-3.024-7.46s.521-.334.243-.752c-.278-.417-.647-.257-.647-.257s-.187.122-.406.38c-.22.256-.7.89-.852 1.233 0 0 1.001-.132 1.662-.605zm-6.091 0c.66.472 1.662.604 1.662.604-.153-.344-.633-.977-.852-1.234-.22-.257-.407-.379-.407-.379s-.368-.16-.647.257c-.278.418.244.751.244.751zM14.963 4.95c1.064.083 1.03 1.036 1.03 1.036v2.016c-.098 1.023-1.03.98-1.03.98H8.935V6.23H7.058v2.754H1.029S.097 9.026 0 8.004V5.986s-.035-.953 1.03-1.036h2.454s-.876-.765-.876-1.836c0-1.07.917-2.614 2.586-2.614 0 0 .939-.063 1.808.813 0 0 .55.578.994 1.266.445-.688.995-1.266.995-1.266.869-.876 1.807-.813 1.807-.813 1.67 0 2.587 1.544 2.587 2.614 0 1.071-.876 1.836-.876 1.836h2.454z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

SvgGiftF.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgGiftF;
exports.default = _default;